export default "__VITE_ASSET__C$Adb3wX__"